// Native-shell (Capacitor) bootstrapping. Every entry point here is a no-op
// on the web — this module must never change web behavior. Plugin modules
// are loaded with dynamic import so the web bundle never executes them.

export async function initNativeShell() {
  const cap = window.Capacitor;
  if (!cap || typeof cap.isNativePlatform !== 'function' || !cap.isNativePlatform()) {
    return;
  }

  // Scopes the safe-area CSS in index.css; never present on the web.
  document.documentElement.classList.add('heyward-native');

  // Let content extend into the notch / status-bar area; the
  // html.heyward-native rules in index.css pad it back out with env() insets.
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport && !viewport.content.includes('viewport-fit')) {
    viewport.content = `${viewport.content}, viewport-fit=cover`;
  }

  try {
    const { App } = await import('@capacitor/app');
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        // At the navigation root, Android convention is to background the
        // app, not kill it.
        App.minimizeApp();
      }
    });
  } catch (error) {
    console.error('Heyward native shell: back-button wiring failed:', error);
  }

  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    // Style.Light = dark text on light backgrounds (matches neutral-50 theme).
    // No setBackgroundColor: Android targetSdk 36 enforces edge-to-edge and
    // ignores it; the safe-area CSS handles the inset instead.
    await StatusBar.setStyle({ style: Style.Light });
  } catch (error) {
    console.error('Heyward native shell: status bar styling failed:', error);
  }
}
